import * as tslib_1 from "tslib";
import { tokenService } from "sbtech-sports-data-api-client";
/**
 * Global configuration for SportDataApi/BFF
 */
var GlobalConfigs = /** @class */ (function () {
    function GlobalConfigs(config) {
        this.apiConfigs = config.apiConfigs;
        this.authorization = config.authorization;
    }
    GlobalConfigs.prototype.setAuthorization = function (authorization) {
        this.authorization = authorization;
        tokenService.apiAccessToken = authorization.token;
    };
    GlobalConfigs.prototype.getAuthorization = function () {
        return this.authorization;
    };
    return GlobalConfigs;
}());
export { GlobalConfigs };
export var GlobalConfig = new GlobalConfigs({
    apiConfigs: {
        sportDataApiUrl: "",
        bffApiUrl: "",
        locale: "",
        betsApiUrl: ""
    },
    authorization: {
        token: ""
    }
});
/**
 * init function initialize GlobalConfig object
 * @param config {GlobalConfig} config object to override the default values
 */
export var init = function (config) {
    if (!Object.isFrozen(GlobalConfig.apiConfigs)) {
        GlobalConfig.apiConfigs = tslib_1.__assign({}, GlobalConfig.apiConfigs, config.apiConfigs);
        Object.freeze(GlobalConfig.apiConfigs);
    }
    GlobalConfig.setAuthorization(tslib_1.__assign({}, GlobalConfig.getAuthorization(), config.authorization));
};
//# sourceMappingURL=init.js.map